import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidate every query that renders product or variant data — the product
 * list, a product detail page, the variant list, and the expandable variant
 * rows. Any mutation that edits a product or variant must call this so no list
 * is left showing stale values after a save.
 */
export function invalidateCatalogQueries(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: ['products'] });
  queryClient.invalidateQueries({ queryKey: ['product'] });
  queryClient.invalidateQueries({ queryKey: ['variants'] });
  queryClient.invalidateQueries({ queryKey: ['product-variants'] });
}
